/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const iccidConstants = {
    LIST_ICCID_POOL: 'iccid_pool_list',
    LIST_ICCID_POOL_SERIAL: 'iccid_pool_list_serial',
    LIST_ICCID_POOL_ITEM: 'iccid_pool_item',
    LIST_ICCID_POOL_ITEM_LIST: 'iccid_pool_item_list',
    LIST_ICCID_POOL_ADD_NEW: 'iccid_pool_add_new',
    LIST_ICCID_POOL_EDIT: 'iccid_pool_add_edit',
    LIST_ICCID_POOL_EDIT_SAVE: 'iccid_pool_add_edit_save',
    LIST_ICCID_POOL_NO_ACTION: 'iccid_pool_no_action',
    LIST_ICCID_POOL_DELETE: 'iccid_pool_delete',

    LIST_ICCID_POOL_NAME_SELECT: 'iccid_pool_name_select',
    LIST_ICCID_POOL_SERIAL_CHOOSE: 'iccid_pool_serial_choose',

    LIST_ICCID_POOL_GET_INDICATED_RANGE: 'iccid_pool_get_indicated_range',
    LIST_ICCID_POOL_GET_TARIFFS: 'list_iccid_pool_get_tariffs',
    LIST_ICCID_POOL_GET_INDICATED_RANGE_DISCOUNT_TEMPLATES: 'list_iccid_pool_get_indicated_range_discount_templates',
    ICCID_POOL_PLATFORM_RESELLERS: 'iccid_pool_platform_resellers',
};

export class iccidActions extends defaultActions {
    static getListPool = (url, filter, actionType, callback, options) =>
        defaultActions.getCollection(url, filter, [{ name: 'iccid', value: 'asc' }], actionType, callback, options);
}
